import { motion } from 'framer-motion';
import { Telemetry } from './Telemetry';
import { CommandRail } from './CommandRail';
import { SelectionPanel } from './SelectionPanel';
import { EventLog } from './EventLog';

/**
 * Heads-up display root.
 *
 * Sits above the R3F canvas in pointer-events:none mode by default; child
 * panels opt back in. The overlay handles entrance animation only; layout
 * is driven by individual panels.
 */
export function HUDRoot(): JSX.Element {
  return (
    <motion.div
      className="tiw-hud"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
      style={{
        position: 'fixed',
        inset: 0,
        pointerEvents: 'none',
        zIndex: 20,
      }}
    >
      <CommandRail />
      <Telemetry />
      <SelectionPanel />
      <EventLog />
    </motion.div>
  );
}
